import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';

import { NotificationApiService } from '../api/notification-api.service';



const { sendNotification } = NotificationApiService();

export const useSendNotification = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return sendNotification(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Notification send successfully")
            },
        },
    );
};
